<template>
  <div class="d-flex position-relative" style="height: inherit">
    <div class="flex-auto-container">
      <div class="chat-navbar">
        <header class="chat-header">

          <!-- Avatar & Name -->
          <div class="d-flex align-items-center">
            <b-avatar
              size="36"
              :src="verifyAsset(sender.avatar)"
              class="mr-1 badge-minimal"
            />
            <div class="d-none d-sm-flex flex-wrap">
              <h6 class="mb-0 username-buy">
                {{ sender.first_name }} {{ sender.last_name }}
              </h6>
              <p variant="info" pill v-if="!isLegacy && deal_active" class="mb-0 avenir-medium badge-chat-active text-overflow-title-chat-proposals">{{$t('creator.offerChat')}} {{deal_active.title }} #{{ deal_id }}</p>
              <b-tooltip v-if="isLegacy" target="campaign" triggers="hover" placement="button">{{$t('creator.about')}} {{local_chat.casting_call ? local_chat.casting_call.title : local_chat.proposal.title }} </b-tooltip>
              <p v-if="isLegacy" id="campaign" class="mb-0 avenir-medium text-overflow-title-chat-proposals">{{$t('creator.about')}} {{local_chat.casting_call ? local_chat.casting_call.title : local_chat.proposal.title }} </p>
            </div>
          </div>


          <!-- Contact Actions -->
          <div class="d-flex align-items-center">
            <b-button
              v-if="!isLegacy && deal_active"
              variant="flat-secondary"
              id="back_general_chat"
              @click="goToGeneralChat"
            >
              <feather-icon
                icon="ArrowLeftIcon"
                size="17"
              />
            </b-button>

            <b-popover  v-if="!isLegacy && deal_active" triggers="hover" target="back_general_chat">{{ $t('creator.backToChat') }}</b-popover>
            <b-button variant="flat-secondary" id="update_chat" @click="updateChat()">
              <feather-icon
                icon="RefreshCwIcon"
                size="17"
              />
              <b-popover triggers="hover" target="update_chat">{{ $t('creator.updateChat') }}</b-popover>
            </b-button>
            <b-button
              v-if="!isLegacy"
              variant="flat-secondary"
              id="archive_chat"
              :disabled="archiving_chat"
              @click="confirmToggleArchiveChat()"
            >
              <feather-icon
                :icon="isChatArchived ? 'InboxIcon' : 'ArchiveIcon'"
                size="17"
              />
              <b-popover triggers="hover" target="archive_chat">{{ isChatArchived ? $t('creator.unarchiveChat') : $t('creator.archiveChat') }}</b-popover>
            </b-button>
            <b-button variant="flat-secondary" id="detail_proposal" @click="openSidebarInfo()" class="d-xl-none btn-open-sider">
              <feather-icon
                icon="InfoIcon"
                size="17"
              />
              <b-popover triggers="hover" target="detail_proposal">{{ $t('creator.detailProposal') }}</b-popover>
            </b-button>
          </div>
        </header>
      </div>

      <!-- User Chat Area -->
      <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="user-chats scroll-area"
        ref="refChatLogPS"
      >
        <div class="chats" :key="`key_local_messages_${change_local_messages}`">
          <div
            v-for="(msg, index) in local_messages"
            :key="msg.sender.id + String(index)"
            class="chat"
            :class="{'chat-left': msg.type_message === 'revision' ? receiver.id !== chat.brand.id : (msg.sender.id !== receiver.id || msg.type_message === 'automated')}"
          >
            <div v-if="msg.type_message === 'revision'" class="chat-bubble-content-wrapper">
              <div class="chat-avatar">
                <b-avatar
                  size="36"
                  :src="avatar_from_brand"
                />
              </div>
              <div class="chat-body m-0">
                <revision-chat 
                  :message="msg" 
                  :chat="local_chat"
                  class="mb-1"
                ></revision-chat>
              </div>
            </div>
            <div v-else-if="msg.type_message === 'deal' && !isLegacy" class="d-flex justify-content-center">
              <div class="px-0 card-deal-custom-container">
                <card-deal-custom :deal="msg.deal_custom" />
              </div>
            </div>
            <div v-else-if="msg.type_message === 'content' && deal_active && (msg && msg.deal_info && deal_active.uuid && msg.deal_info.uuid) && !isLegacy" class="chat-bubble-content-wrapper">
              <div class="chat-avatar">
                <b-avatar
                  size="36"
                  :src="msg.sender.id === receiver.id ? verifyAsset(receiver.profile_image) : verifyAsset(msg.sender.avatar)"
                />
              </div>
              <div class="chat-body m-0 my-1">
                <view-file-chats
                  :message="msg"
                  @update_chat="updateChat"
                  @request_sent="handleRequestSentChatDeal"
                  @approved="handleApprovedChatDeal"
                  :show_btns="msg.show_btns"
                  class="view-file-chats-component mb-1"
                />
              </div>
            </div>
            <div v-else-if="msg.type_message === 'content' && !isLegacy" class="chat-bubble-content-wrapper">
              <div class="chat-avatar">
                <b-avatar
                  size="36"
                  :src="msg.sender.id === receiver.id ? verifyAsset(receiver.profile_image) : verifyAsset(msg.sender.avatar)"
                />
              </div>
              <div class="chat-body m-0 my-1">
                <view-file-chats
                  :message="msg"
                  @update_chat="updateChat"
                  @request_sent="handleRequestSentChatDeal"
                  @approved="handleApprovedChatDeal"
                  :show_btns="msg.show_btns"
                  class="view-file-chats-component mb-1"
                />
              </div>
            </div>
            <div v-else-if="msg.type_message === 'link' && !isLegacy" class="chat-bubble-content-wrapper">
              <div class="chat-avatar">
                <b-avatar
                  size="36"
                  :src="msg.sender.id === receiver.id ? verifyAsset(receiver.profile_image) : verifyAsset(msg.sender.avatar)"
                />
              </div>
              <div class="chat-body m-0">
                <view-links-chat
                  :message="msg"
                  @request_sent="handleRequestSentChatDeal"
                  @approved="handleApprovedChatDeal"
                  :show_btns="msg.show_btns_links"
                />
              </div>
            </div>
            
            <!-- Bubble chat -->
            <div v-else>
              <div :class="`d-flex justify-content-center ${index === 0 ? 'm-0' : 'my-3'}`" v-if="msg.is_same_date">
                <p class="badge-date-chat">{{ getFormatTimeDifferenceChat(msg.sended_at, $i18n.locale) }}</p>
              </div>
              <div class="chat-avatar">
                <b-avatar
                  size="36"
                  :src="msg.type_message === 'automated' ? require('@/assets/images/mascot/dil_small.jpg') : msg.sender.id === receiver.id ? verifyAsset(receiver.profile_image) : verifyAsset(msg.sender.avatar)"
                />
              </div>
              <div class="chat-body position-relative" ref="chat_body">
                <div :class="`chat-content ${msg.type_message === 'automated' ? 'chat-bot' : ''} mt-1`">
                  <div v-if="msg.type_message === 'text'" class="chat-message">
                    <div
                      v-if="msg.chat_deals && !deal_active"
                      :id="`popover-info-${msg.uuid}`"
                    >
                      <p v-html="formatTextLinks(msg.message)"></p>
                    </div>
                    <popover-info
                      v-if="msg.chat_deals && !deal_active"
                      :target="`popover-info-${msg.uuid}`"
                      :title="msg.chat_deals.deal.title"
                      :description="msg.chat_deals.deal.description"
                      :price="msg.chat_deals.deal.price"
                    />
                    
                    <p v-else v-html="formatTextLinks(msg.message)"></p>
                  </div>
                  <div v-else-if="msg.type_message === 'automated'">
                    <p>{{ msg.message }}</p>
                  </div>
                  <div v-else-if="msg.type_message === 'file'">
                    <a class="d-flex" :href="verifyAsset(msg.file)" target="_blank">
                      <div class="d-flex">  
                        <feather-icon
                          icon="FileIcon"
                          size="17"
                          class="cursor-pointer d-sm-block d-none mr-1"
                        />
                        <p>{{ $t('creator.viewArchive') }}</p>
                      </div>
                    </a>
                  </div>
                  <div v-else-if="msg.type_message === 'content'">
                    <a :class="`d-flex text-dark`" @click="openModalContent(msg)">
                      <div class="d-flex">  
                        <feather-icon
                          icon="FileIcon"
                          size="17"
                          class="cursor-pointer d-sm-block d-none mr-1"
                        />
                        <p>{{ $t('creator.viewArchive') }}</p>
                      </div>
                    </a>
                  </div>
                  <div v-else-if="msg.type_message === 'link'">
                    <div :class="`d-flex text-dark`">
                      <div class="d-flex">  
                        <feather-icon
                          icon="LinkIcon"
                          size="17"
                          class="cursor-pointer d-sm-block d-none mr-1"
                        />
                        <p v-html="formatTextLinks(msg.message)"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="hour-message-container">
                <span class="hour-message">
                  <div class="">
                    {{formatMessageTime(msg.sended_at)}}
                    <b-icon 
                      icon="check2-all" 
                      :class="{'seen-color': msg.seen}" 
                      class="check-icon-seen" 
                      v-if="msg.seen !== undefined && isRightSide(msg.sender_id)"
                    ></b-icon>
                  </div>
                </span>
              </div>
            </div>

          </div>
          <!-- CONTAINER EXISTS AN EMAIL OR PHONE IN MESSAGE -->
          <div class="container-msg-restrincted" v-if="existsEmailOrPhoneOrUlr(message, !local_chat.is_saled)">
            <div class="bar-color"></div>
            <p>Detectamos que tu mensaje contiene un enlace externo. Si tiene información de contacto, BrandMe puede suspender tu cuenta.</p>
            <div class="d-flex justify-content-between">
              <span>Elige "Editar" para modificar tu mensaje</span>
              <b-link @click="$refs.textarea.focus()">Editar</b-link>
            </div>
          </div>
          <!-- -------------------------------------------- -->
          <div v-if="!is_brand && !isLegacy" :key="`can_send_file_${key_can_send_files}`">
            <div 
              v-for="deal in deals_can_send_files" 
              :key="deal.uuid" 
              class="chat"
              :class="{'chat-left': receiver.id !== chat.brand.id}"
            >
              <div class="chat-bubble-content-wrapper" v-if="deal_active">
                <div class="chat-avatar" v-if="deal.uuid === deal_active.chat_deal_uuid">
                  <b-avatar
                    size="36"
                    :src="verifyAsset(chat.brand.avatar)"
                  />
                </div>
                <div class="chat-body m-0">
                  <upload-contents-chat 
                    :chat="local_chat" 
                    :chat_deal="deal"
                    :is_legacy="isLegacy"
                    @to_bottom="scrollToBottomInChatLog" 
                    @uploaded_contents="updateContents"
                    v-if="deal.uuid === deal_active.chat_deal_uuid"
                  />
                </div>
              </div>
              <div class="chat-bubble-content-wrapper w-100" v-else>
                <div class="chat-avatar">
                  <b-avatar
                    size="36"
                    :src="verifyAsset(chat.brand.avatar)"
                  />
                </div>
                <div class="chat-body w-100 m-0">
                  <upload-contents-chat 
                    :chat="local_chat" 
                    :chat_deal="deal"
                    :is_legacy="isLegacy"
                    @to_bottom="scrollToBottomInChatLog" 
                    @uploaded_contents="updateContents"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="is_brand && !isLegacy && !hasMessages && !hasChatDeals">
            <request-price :chat="local_chat" @update_chat="updateChat" :is_legacy="isLegacy"/>
          </div>
          <div v-if="!is_brand && !isLegacy">
            <div 
              v-for="deal in deals_can_send_links" 
              :key="deal.uuid" 
              class="chat"
              :class="{'chat-left': receiver.id !== chat.brand.id}"
            >
              <div class="chat-bubble-content-wrapper" v-if="deal_active">
                <div class="chat-avatar" v-if="deal.uuid === deal_active.chat_deal_uuid">
                  <b-avatar
                    size="36"
                    :src="verifyAsset(chat.brand.avatar)"
                  />
                </div>
                <div class="chat-body m-0">
                  <upload-links-chat class=""
                    :chat="local_chat" 
                    :chat_deal="deal"
                    :is_legacy="isLegacy"
                    @to_bottom="scrollToBottomInChatLog"
                    @uploaded_contents="updateContents"
                    v-if="deal.uuid === deal_active.chat_deal_uuid"
                  />
                </div>
              </div>
              <div class="chat-bubble-content-wrapper w-100" v-else>
                <div class="chat-avatar">
                  <b-avatar
                    size="36"
                    :src="verifyAsset(chat.brand.avatar)"
                  />
                </div>
                <div class="chat-body w-100 m-0">
                  <upload-links-chat class="w-100"
                    :chat="local_chat" 
                    :chat_deal="deal"
                    :is_legacy="isLegacy"
                    @to_bottom="scrollToBottomInChatLog"
                    @uploaded_contents="updateContents"
                  />
                </div>
              </div>
            </div>
          </div>
         
          <div v-if="local_chat.is_saled" class="chat chat-left w-100">
            <div class="w-100" v-if="seller_status === 'pending'">
              <accpet-decline-chat @accept_chat="updateChat" @declined_chat="declinedChat" v-if="receiver.id === local_chat.creator.id" :chat="local_chat"/>
            </div>
            <div class="w-100" v-if="seller_status === 'approved'">
              <upload-contents-chat v-if="status_contents === 'creating' && receiver.id === local_chat.creator.id" :chat="local_chat" @to_bottom="scrollToBottomInChatLog" @uploaded_contents="updateChat"/>
              <upload-links-chat class="mt-1" v-if="status_contents === 'send_links' && receiver.id === local_chat.creator.id" :chat="local_chat" @to_bottom="scrollToBottomInChatLog" @uploaded_contents="updateChat"/>
              <review-contents-chat v-if="status_contents === 'review' && !is_completed_status && receiver.id === local_chat.brand.id" :chat="local_chat" @update_chat="updateChat"/>
              <review-links-chat v-if="status_contents === 'approved_links' &&!is_completed_status && receiver.id === local_chat.brand.id" :chat="local_chat" @update_chat="updateChat"/>
            </div>
            <div class="w-100" v-if="checkIsRequestingPrice()">
              <request-price v-if="receiver.id === local_chat.brand.id" :chat="local_chat" @update_chat="updateChat"/>
            </div>
          </div>
        </div>
      </vue-perfect-scrollbar>

      <!-- Message Input -->
      <b-form
        v-if="can_send_message"
        class="chat-app-form position-relative"
        @submit.prevent="sendMessage"
      >
        <upload-files @send_files="sendFiles" @close_upload_files="show_upload_files = false" v-if="show_upload_files"/>
        <b-input-group class="input-group-merge mr-1">

          <textarea
            ref="textarea"
            class="textarea-send-message"
            v-model="message"
            :placeholder="$t('creator.enterMessage')"
            :disabled="loaded_files"
            autocomplete="off"
            rows="1"
            @keydown.enter.exact.prevent="sendMessage"
            @keydown.enter.shift.stop
            @keyup="convertedEmojis"
          />
          <div class="container-badges-files" v-if="files.length > 0">
            <div class="loader-uploading-files" v-if="loaded_files">
              <b-spinner class="spinner-uploading-files"></b-spinner>
            </div>
          </div>
        </b-input-group>
        <b-popover triggers="hover" target="add_custom_deal">{{$t('creator.addCustomDeal')}}</b-popover>
        <b-button
          v-if="!is_brand && !isLegacy"
          id="add_custom_deal"
          variant="send-message-chat"
          type="submit"
          class="send-message-chat background-blue px-1 mr-05"
          @click="is_adding_deal = true"
        >
          <b-img src="@/assets/images/icons/dollar-empty.svg" class="icon-svg"/>
        </b-button>
        <b-button
          variant="send-message-chat"
          type="submit"
          class="send-message-chat px-1"
          ref="send-message-chat"
          :class="{ 'background-blue': canSendMessage }"
          :disabled="!canSendMessage"
        >
          <b-img src="@/assets/images/icons/message.svg" class="message-icon-svg"></b-img>
        </b-button>
      </b-form>

        <div
          v-if="!can_send_message && (!local_chat.is_brandme_talent || isChatArchived)"
          ref="chatDeclinedMessage"
          class="chat-app-form"
        >
        <message-decline-chat
        :title="declineTitle"
        :text="declineText"
        />
        </div>

        <div
          v-if="!can_send_message && !isChatArchived && local_chat.is_brandme_talent && receiver.id === local_chat.brand.id && free_plan"
          ref="chatUpgradeMessage"
          class="chat-app-form"
        >
          <upgrade-plan/>
        </div>
    </div>
    <b-sidebar v-model="open_modal" right shadow backdrop class="sidebar-chat" scroll v-if="open_modal">
      <template #header>
        <div class="dropdown-sales-options-sidebar">
          <b-dropdown block no-caret variant="outline-gray-light" class="d-flex align-items-center" v-if="!isLegacy">
          <template #button-content>
            <div class="text-left">
              <span class="">
                  {{$t('creator.option_selected_dropdown_chat_deals').find((option) => option.value === option_selected_dropdown_chat_deals).text}}
                <feather-icon icon="ChevronDownIcon"></feather-icon>
              </span>
            </div>
          </template>
          <b-dropdown-item :disabled="option.value === 'deals_paid' && !hasChatDeals" @click="changeOption(option.value)" v-for="option in $t('creator.option_selected_dropdown_chat_deals')" :key="option.value">{{option.text}}</b-dropdown-item>
        </b-dropdown>
        <dropdown-chat-states
          v-else
          :chat="local_chat" 
          :proposals_user="proposals_user" 
          :option_selected_dropdown="option_selected_dropdown"
          @change_dropdown="changeDropdown"
          @change_proposal="changeProposal"
        ></dropdown-chat-states>
        </div>
      </template>
      <preview 
        :showEdit="false" 
        :proposal_dad="proposal_active"
        :class_dad="'px-1'"
        v-if="proposal_active && option_selected_dropdown === 'proposal_detail' && isLegacy" 
        :is_sidebar="true"
        :key="update_preview"
      />

      <div v-if="!isLegacy && option_selected_dropdown_chat_deals === 'deals_paid'" class="px-3">
        <b-button
          v-if="deal_active"
          variant="flat-primary"
          block
          class="d-flex align-items-center justify-content-center back-general-chat-btn mb-1"
          @click="goToGeneralChat"
        >
          <feather-icon icon="ArrowLeftIcon" size="16" class="mr-50" />
          {{ $t('creator.backToChat') }}
        </b-button>
        <deal-paid-info
          v-for="deal in deals_paid"
          :key="deal.uuid"
          :deal="deal"
          @select-deal="getMsjChatDeal"
          :active_card="active_card_chat_uuid === deal.chat_deal_uuid"
        />
      </div>
      <view-proposals
        :key="update_proposals"
        v-if="!isLegacy && option_selected_dropdown_chat_deals === 'proposal_detail'"
        :is_in_sidebar="true"
        :force_show_buy_button="is_brand"
        :vanity_name_dad="getVanityNameFromService(local_chat)"
        :chat_uuid="local_chat.uuid"
        class="p-1"
        @update_deals="handleUpdateDeals"
        @close_siderbar="handleUpdateDeals"
      />

      <detail-casting-call 
        :show_title="false" 
        :casting_call="local_chat.casting_call"
        v-if="local_chat.casting_call && option_selected_dropdown === 'casting_call_detail'"
        :is_sidebar="true"
      />
      <state-sale 
        v-if="option_selected_dropdown === 'order_status' || option_selected_dropdown === 'order_invoice'" 
        class="w-100 p-1" 
        :chat_dad="local_chat"
        :is_invoice="option_selected_dropdown === 'order_invoice'"
      ></state-sale>
    </b-sidebar>
    <div class="container-right-side d-none d-xl-block">    
      <div class="dropdown-sales-options">
        <b-dropdown block no-caret variant="outline-gray-light" class="d-flex align-items-center" v-if="!isLegacy">
          <template #button-content>
            <div class="text-left">
              <span class="">
                  {{$t('creator.option_selected_dropdown_chat_deals').find((option) => option.value === option_selected_dropdown_chat_deals).text}}
                  <feather-icon icon="ChevronDownIcon"></feather-icon>
              </span>
            </div>
          </template>
          <b-dropdown-item :disabled="option.value === 'deals_paid' && !hasChatDeals" @click="changeOption(option.value)" v-for="option in $t('creator.option_selected_dropdown_chat_deals')" :key="option.value">{{option.text}}</b-dropdown-item>
        </b-dropdown>
        <dropdown-chat-states
          v-else
          :chat="local_chat" 
          :proposals_user="proposals_user" 
          :option_selected_dropdown="option_selected_dropdown"
          @change_dropdown="changeDropdown"
          @change_proposal="changeProposal"
        ></dropdown-chat-states>
      </div>
      <preview 
        :showEdit="false" 
        :proposal_dad="proposal_active"
        :class_dad="'px-1'"
        class="width-proposal-right-chat"
        v-if="proposal_active && option_selected_dropdown === 'proposal_detail' && isLegacy" 
        :is_sidebar="true"
        :key="update_preview"
      />

      <!-- List of deals paid -->
      <div v-if="!isLegacy && option_selected_dropdown_chat_deals === 'deals_paid'" class="width-proposal-right-chat p-1">
        <b-button
          v-if="deal_active"
          variant="flat-primary"
          block
          class="d-flex align-items-center justify-content-center back-general-chat-btn mb-1"
          @click="goToGeneralChat"
        >
          <feather-icon icon="ArrowLeftIcon" size="16" class="mr-50" />
          {{ $t('creator.backToChat') }}
        </b-button>
        <deal-paid-info
          v-for="(deal, index) in deals_paid"
          :key="`chat-deal-${deal.uuid}-${index}`"
          :deal="deal"
          @select-deal="getMsjChatDeal"
          :active_card="active_card_chat_uuid === deal.chat_deal_uuid"
        />
      </div>
      <!------------------------>
      <view-proposals
        :key="update_proposals"
        v-if="!isLegacy && option_selected_dropdown_chat_deals === 'proposal_detail'"
        :is_in_sidebar="true"
        :force_show_buy_button="is_brand"
        :vanity_name_dad="getVanityNameFromService(local_chat)"
        :chat_uuid="local_chat.uuid"
        class="p-1"
        @close_siderbar="handleUpdateDeals"
      />
      <detail-casting-call 
        :show_title="false" 
        :casting_call="local_chat.casting_call" 
        class="width-proposal-right-chat" 
        v-if="local_chat.casting_call && option_selected_dropdown === 'casting_call_detail'"
        :is_sidebar="true"
      />
      <state-sale 
        v-if="option_selected_dropdown === 'order_status' || option_selected_dropdown === 'order_invoice'" 
        class="width-proposal-right-chat" 
        :chat_dad="local_chat"
        :is_invoice="option_selected_dropdown === 'order_invoice'"
      ></state-sale>
    </div>
    <div class="loader-inner-active-chat" v-if="inner_loader">
      <b-spinner class="spinner-inner-active-chat"></b-spinner>
    </div>

    <modal-brandme size="sm" :show_modal="show_modal_url" :key="update_modal_url">
      <template #body>
        <div class="text-center">
          <h2>Estás por salir de BrandMe</h2>
          <p class="avenir-medium text-ellipsis-url">Estás por ingresar a {{ url_to_go }}</p>
          <p class="avenir-medium">¿Estas seguro que quieres continuar?</p>
  
          <b-button variant="blue-button" class="blue-button mb-1" @click="goToUrl()">Continuar</b-button>
        </div>
      </template>
    </modal-brandme>
    <modal-content-preview
      v-if="open_modal_content"
      :open_modal="open_modal_content" 
      :asset_url="verifyAsset(asset_content_url)"
      :info_creator="info_chat"
      :type_content="content_type"
      @close_modal="open_modal_content = false"
      :download="true"
      :key="update_modal_content"
    />
    <sidebar-edit-proposal
      v-if="is_adding_deal"
      class="open-sidebar-edit-proposal" 
      :open_sidebar_edit="is_adding_deal"
      :key="is_adding_deal"
      :section_dad="'deals'"
      :data_for_sidebar="{}"
      :chat_uuid="local_chat.uuid"
      @update_private_deal="handleUpdateDeals"
      @close_siderbar="is_adding_deal = false"
     
    ></sidebar-edit-proposal>
  </div>
</template>

<script>
import {
  BIcon,
  BPopover,
  BTooltip,
  BAvatar,
  BForm,
  BInputGroup,
  BButton,
  BSidebar,
  BSpinner,
  BLink,
  BImg,
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import chat_service from '@/services/chat';
import preview from '@/views/pages/proposals/stepper/viewProposal/viewProposal.vue';
import StateSale from '@/views/components/chat/StateSale.vue';
import accpetDeclineChat from './accpetDeclineChat.vue';
import messageDeclineChat from './messageDeclineChat.vue'
import uploadContentsChat from './uploadContentsChat.vue'
import uploadFiles from './uploadFiles.vue'
import reviewContentsChat from './reviewContentsChat.vue';
import revisionChat from '@/views/pages/proposals/chat/revisionChat.vue';
import detailCastingCall from '../../casting-calls/pitch-stepper/detailCastingCall.vue';
import uploadLinksChat from './uploadLinksChat.vue';
import reviewLinksChat from './reviewLinksChat.vue';
import requestPrice from './requestPrice.vue'
import { getUserData } from '@/libs/utils/user';
import { existsEmailOrPhoneOrUlr, getIdFromDate } from '@/libs/utils/formats'
import { verifyAsset } from '@/libs/utils/urls'
import { getFormatTimeDifferenceChat, getDatev2 } from '@/libs/utils/times'
import { getVanityNameFromService } from '@/domain/proposal/proposal.domain'
import EmojiConvertor from 'emoji-js'
import { submitRequestDealsPaid, submitRequestMessageChatDeal } from '@/application/proposals/chats.usecase';
//Domain
import { shouldIncludeMessage } from '@/domain/chat/chat.domain';

const emoji = new EmojiConvertor()
emoji.replace_mode = 'unified'
emoji.allow_native = true

import upgradePlan from './upgradePlan.vue';

const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');

export default {
  name: 'activeChat',
  components: {
    BIcon,
    BPopover,
    BImg,
    BTooltip,
    BAvatar,
    BForm,
    BInputGroup,
    BButton,
    BSpinner,
    BSidebar,
    BLink,
    VuePerfectScrollbar,
    preview,
    StateSale,
    accpetDeclineChat,
    messageDeclineChat,
    uploadContentsChat,
    reviewContentsChat,
    revisionChat,
    detailCastingCall,
    uploadFiles,
    uploadLinksChat,
    reviewLinksChat,
    dropdownChatStates: () => import('@/views/components/chat/dropdownChatStates.vue'),
    ModalBrandme: () => import('@/views/components/modal/ModalBrandme.vue'),
    ModalContentPreview: () => import('@/views/components/modal/ModalContentPreview.vue'),
    requestPrice,
    upgradePlan,
    viewFileChats: () => import('@/views/pages/proposals/chat/viewFileChats.vue'),
    viewLinksChat: () => import('@/views/pages/proposals/chat/viewLinksChats.vue'),
    ViewProposals: () => import('@/views/pages/proposals/stepper/viewProposals/viewProposals.vue'),
    dealPaidInfo: () => import('@/views/pages/proposals/chat/dealPaidInfo.vue'),
    BDropdown,
    BDropdownItem,
    PopoverInfo: () => import("@/views/pages/proposals/chat/popoverInfoDeal.vue"),
    CardDealCustom: () => import('@/views/pages/proposals/chat/cardDealCustom.vue'),
    SidebarEditProposal: () => import('@/views/pages/proposals/stepper/sidebarEditProposal.vue'),
  },
  props: {
    chat: {
      type: Object,
      required: true,
    },
    inner_loader: {
      type: Boolean,
      default: false,
    },
    proposals_user: {
      type: Array,
      default: () => {
        return []
      }
    },
    messages_format: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      update_proposals: 0,
      option_selected_dropdown_chat_deals: 'proposal_detail',
      deals_paid: [],
      loading_deals_paid: false,
      seller_status: '',
      message: '',
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
      },
      receiver: getUserData(),
      files: [],
      open_modal: false,
      loaded_files: false,
      option_selected_dropdown: this.chat.casting_call ? 'casting_call_detail' : this.chat.is_saled ? 'order_status' : 'proposal_detail',
      can_send_message: true,
      archiving_chat: false,
      status_contents: '',
      is_completed_status: false,
      show_upload_files: false,
      ready_to_send_ws: true,
      proposal_active: {},
      update_preview: false,
      show_modal_url: false,
      update_modal_url: false,
      url_to_go: '',
      links: [],
      free_plan: false,
      open_modal_content: false,
      asset_content_url: '',
      update_modal_content: 0,
      content_type: '',
      info_chat: {},
      deals_can_send_files: [],
      deals_can_send_links: [],
      is_adding_deal: false,
      active_card_chat_uuid: null,
      deal_active: null,
      local_messages: [],
      change_local_messages: 0,
      local_chat: { ...this.chat },
      key_can_send_files: 0,
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.textarea) this.$refs.textarea.focus();
      this.scrollToBottomInChatLog();
      setTimeout(() => this.scrollToBottomInChatLog(), 300);
    });
  },
  computed: {
    avatar_from_brand() {
      return this.receiver.id === this.chat.brand.id ? verifyAsset(this.receiver.profile_image) : verifyAsset(this.chat.brand.avatar)
    },
    deal_id() {
      return getIdFromDate(this.deal_active?.order_statuses?.created_at ?? new Date());
    },
    sender() {
      return this.receiver.id === this.local_chat.brand.id ? this.local_chat.creator : this.local_chat.brand
    },
    hasMessages() {
      return (this.local_messages?.length ?? 0) > 0
    },

    hasChatDeals() {
      return (this.local_chat?.chat_deals?.length ?? 0) > 0
    },
    is_brand() {
      return getUserData() && getUserData().main_group.name !== 'creator'
    },
    isLegacy() {
      return this.local_chat?.is_legacy ?? true
    },
    canSendMessage() {
      return (
        (this.message.trim().length > 0 || this.files.length > 0) &&
        !existsEmailOrPhoneOrUlr(this.message, !this.local_chat.is_saled)
      )
    },
    lastOrderStatus() {
      const list = this.local_chat?.order_status
      if (!Array.isArray(list) || !list.length) return null
      return list.at(-1) 
    },

    isChatDeclined() {
      return this.lastOrderStatus?.status === 'declined'
    },

    isChatArchived() {
      return !!this.local_chat?.status && this.local_chat.status !== 'active'
    },

    declineTitle() {
      if (this.isChatArchived) return this.$t('chat.archivedChatTitle')
      return this.isChatDeclined ? this.$t('chat.declinedChat') : this.$t('chat.waitTitle')
    },

    declineText() {
      if (this.isChatArchived) return this.$t('chat.archivedChatError')
      return this.isChatDeclined ? this.$t('chat.chatNoLonger') : this.$t('chat.waitingResponse')
    }

  },
  created() {
    this.syncChatState(true)

    this.$root.$on('new_message', (data) => {

      if (this.local_chat.uuid === data.body.chat_uuid) {
        const ready_message = this.local_messages.find(msg => msg.uuid === data.body.message_uuid)

        if (!ready_message) {
          if (!this.deal_active || (this.deal_active && data.body.message_serialized?.chat_deal?.uuid === this.deal_active.chat_deal_uuid)) {
            const obj = this.setFormatMsg(data.body.message_serialized)
            obj.deal_info = this.deal_active

            this.local_messages.push(obj)
            this.change_local_messages += 1

            this.scheduleScrollToBottom()

            const ws_mark_reader = !this.isLegacy ? chat_service.markAsReadedV4 : chat_service.markAsReaded;

            ws_mark_reader(this.local_chat.uuid).then(() => {
            })
          }
        }
      }
    });
    this.$root.$on('deal_private_created', (data) => {

      if (this.local_chat.uuid === data.body.chat_uuid) {

        const readyDeal = this.local_messages.find(
          msg => msg.uuid === data.message_id
        )

        if (!readyDeal) {
          const obj = {
            uuid: data.message_id,
            sender: this.sender,
            type_message: 'deal',
            sended_at: Date.now(),
            file: '',
            is_same_date: false,
            deal_custom: data.body,
          }

          this.local_messages.push(obj)
          
          this.scheduleScrollToBottom()
          
        }
      }
    })
    this.$root.$on('chat_active', (data) => {
      if (this.local_chat.uuid === data.body.chat_uuid) {
        this.can_send_message = true;
      }
    });

    this.$root.$on('chat_viewed', (data) => {
      if (this.local_chat.uuid === data.body.detail.chat_uuid) {
        this.local_messages.forEach(msg => {
          msg.seen = true;
        })
      }
    });

    this.$root.$on('files_uploaded', (data) => {
      if (this.local_chat.uuid === data.body.detail.chat_uuid) {
        this.local_chat = data.body.detail.detail_chat

        if (this.deal_active) {
          this.getMsjChatDeal(this.deal_active)
          setTimeout(() => this.scrollToBottomInChatLog(), 300);
        } else {
          this.local_messages = this.buildFormattedMessages(data.body.detail.detail_chat.messages)
          this.lastMsjContent()
          this.lastMsjLinks()
          this.candSendFiles()
          this.canSendLinks()
          setTimeout(() => this.scrollToBottomInChatLog(), 300);
        }

        this.getDealsPaid()
      }
    });

    setTimeout(() => {
      this.links = document.getElementsByClassName('link-url-chat')
      this.links.forEach(link => {
        link.addEventListener('click', this.openModal);
      });
    }, 50);
  },
  methods: {
    getUserData,
    getFormatTimeDifferenceChat,
    verifyAsset,
    existsEmailOrPhoneOrUlr,
    syncChatState(isConversationChange = false) {
      this.lastMsjContent()
      this.lastMsjLinks()
      this.candSendFiles()
      this.canSendLinks()

      if (isConversationChange) {
        this.option_selected_dropdown = this.local_chat.casting_call ? 'casting_call_detail' : this.local_chat.is_saled ? 'order_status' : 'proposal_detail'
        this.option_selected_dropdown_chat_deals = 'proposal_detail'
        this.deals_paid = []
        this.deal_active = null
        this.active_card_chat_uuid = null
        this.is_adding_deal = false
        this.open_modal = false
        this.open_modal_content = false
        this.message = ''
        this.files = []
        this.show_upload_files = false
        this.loaded_files = false
      }

      if (this.local_chat.user_proposal) this.seller_status = this.local_chat.user_proposal.seller_status
      else if (!this.local_chat.user_proposal && this.local_chat.casting_call) this.seller_status = 'approved'
      else this.seller_status = ''

      this.can_send_message = this.getCanSendMessage()
      this.status_contents = !this.local_chat.is_brandme_talent && this.local_chat.is_saled ? this.local_chat.order_status[this.local_chat.order_status.length - 1].status : ''
      this.is_completed_status = !this.local_chat.is_brandme_talent && this.local_chat.is_saled ? this.local_chat.order_status[this.local_chat.order_status.length - 1].is_completed : false
      this.proposal_active = this.local_chat.proposal
      this.checkFrrePlan()

      if (isConversationChange && this.hasChatDeals) {
        this.option_selected_dropdown_chat_deals = 'deals_paid'
        this.changeOption('deals_paid')
      }
    },
    handleUpdateDeals(response) {
      this.is_adding_deal = false
      this.update_proposals++

      if (response) {
        const obj = {
          uuid: response.uuid,
          sender: this.sender,
          type_message: 'deal',
          sended_at: Date.now(),
          file: '',
          is_same_date: false,
          deal_custom: response,
        }

        this.local_messages.push(obj)

        this.scheduleScrollToBottom()
      }
    },
    goToGeneralChat() {
      this.deal_active = null
      this.active_card_chat_uuid = null
      this.updateChat()
    },
    async changeOption(option) {
      this.option_selected_dropdown_chat_deals = option;

      if (option === 'deals_paid' && !this.deals_paid.length) {
        await this.getDealsPaid();
      }
    },
    async getMsjChatDeal(deal) {
      try {
        const response = await submitRequestMessageChatDeal({
          uuid_chat_deal: deal.chat_deal_uuid
        });

        const results = response || [];
        this.active_card_chat_uuid = deal.chat_deal_uuid;


        this.local_messages = this.buildFormattedMessages(results).map(msg => {
          const formatted = { ...msg }

          formatted.deal_info = deal;

          return formatted;
        });
        this.change_local_messages += 1;
        this.deal_active = deal;
        this.open_modal = false;
        this.$nextTick(() => this.scrollToBottomInChatLog())
        this.lastMsjContent()
        this.lastMsjLinks()
        this.candSendFiles()
        this.canSendLinks()


      } catch (error) {
        console.error("Error getting message chat deal", error);
      }
    },
    async getDealsPaid() {
      try {
        this.loading_deals_paid = true;

        const response = await submitRequestDealsPaid({
          uuid_chat_deal: this.local_chat.uuid
        });

        const results = response.results || [];

        this.deals_paid = results.map(item => ({
          uuid: item.deal.uuid,
          chat_deal_uuid: item.uuid,
          title: item.deal.title,
          price: item.deal.price,
          order_statuses: item.order_statuses[item.order_statuses.length - 1]
        }));

      } catch (error) {
        console.error("Error getting deals paid", error);
      } finally {
        this.loading_deals_paid = false;
      }
    },
    
    getVanityNameFromService,
    getDealsByStatus(status) {
      if (!this.local_chat.chat_deals?.length) return [];

      return this.local_chat.chat_deals.filter(deal => {
        const last_status = deal.order_statuses?.slice(-1)[0]?.status;
        return last_status === status;
      });
    },
    candSendFiles() {
      this.deals_can_send_files = this.getDealsByStatus("creating");
      this.key_can_send_files += 1;
    },

    canSendLinks() {
      this.deals_can_send_links = this.getDealsByStatus("waiting_links");
    },
    lastMsjContent() {
      this.processLastMessages("content", "show_btns",
        (statuses) => statuses?.length && statuses.at(-1).status === "content_submitted" && statuses.at(-1).is_completed
      );
    },

    lastMsjLinks() {
      this.processLastMessages("link","show_btns_links",
        (statuses) => statuses?.length && statuses.at(-1).status === "approved_links"
      );
    },
    processLastMessages(type, prop, statusCheck) {
      const grouped = {};

      this.local_messages.forEach(msg => {
        msg[prop] = false;

        if (msg.type_message === type && msg.chat_deals?.uuid) {
          const uuid = msg.chat_deals.uuid;
          (grouped[uuid] ||= []).push(msg);
        }
      });

      Object.values(grouped).forEach(messages => {
        const last_msg = messages.at(-1);
        if (!last_msg) return;

        const order_statuses = last_msg.chat_deals.order_statuses;

        if (this.is_brand && statusCheck(order_statuses)) {
          last_msg[prop] = true;
        }
      });
    },
    buildFormattedMessages(messages) {
      let previous_message_date = null

      return messages.reduce((result, msg) => {
        if (!shouldIncludeMessage(msg, this.receiver.id, this.local_chat)) return result

        result.push(this.setFormatMsg(msg, previous_message_date))
        previous_message_date = getDatev2(new Date(msg.sended_at))

        return result
      }, [])
    },
    getPreviousMessageDate(messages = this.local_messages) {
      if (!Array.isArray(messages) || messages.length === 0) return null

      const last_message = messages[messages.length - 1]
      return getDatev2(new Date(last_message.sended_at))
    },
    convertedEmojis(e) {
      if (e.key === ' ' || e.key === 'Enter') {
        const value = this.message
        const parsed = this.parseEmojis(value)

        if (parsed !== value) {
          this.message = parsed
        }
      }
    },
    updateChatFooterHeight() {
      this.$nextTick(() => {
        const chat = this.getChatLogElement()
        if (!chat) return

        let height = 65

        if (this.can_send_message && this.$refs.chatForm) {
          height = this.$refs.chatForm.$el ? this.$refs.chatForm.$el.offsetHeight : this.$refs.chatForm.offsetHeight
        } else if (this.$refs.chatDeclinedMessage) {
          height = this.$refs.chatDeclinedMessage.offsetHeight
        } else if (this.$refs.chatUpgradeMessage) {
          height = this.$refs.chatUpgradeMessage.offsetHeight
        }

        chat.style.setProperty('--form-height', `${height}px`)
        this.scrollToBottomInChatLog()
      })
    },
    openModalContent(message) {
      const asset = message.file
      const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv']
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'avif', 'heic']
      let type = 'unknown'

      try {
        const url = new URL(asset, window.location.origin)
        const ext = url.pathname.split('.').pop().toLowerCase()
        if (videoExtensions.includes(ext)) {
          type = 'video'
        } else if (imageExtensions.includes(ext)) {
          type = 'image'
        }
      } catch {
        type = 'unknown'
      }
      this.asset_content_url = asset
      this.content_type = type
      this.info_chat = message
      this.open_modal_content = true
      this.update_modal_content += 1
    },
    checkFrrePlan() {
      this.free_plan = this.receiver.current_plan.name === 'Free'
    },
    checkIsRequestingPrice() {
      const review_status = this.local_chat.order_status.find((i) => i.status === 'price_requesting');
      if (!review_status) return false;
      return !review_status.is_completed;
    },
    formatTextLinks(text) {
      const urlRegex = /((https?:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?)\b/gi
      return text.replace(urlRegex, '<a style="text-decoration: underline; color: #0096fe;" class="link-url-chat">$1</a>');
    },
    openModal(value) {
      this.show_modal_url = true;
      this.update_modal_url = !this.update_modal_url;
      this.url_to_go = this.addProtocolToUrl(value.srcElement.innerText);
    },
    addProtocolToUrl(url) {
      if (!/^https?:\/\//i.test(url)) {
        url = `https://${url}`;
      }
      return url;
    },
    goToUrl() {
      window.location.href = this.url_to_go;
    },
    getCanSendMessage() {
      if (this.isChatArchived) return false;

      if (!this.local_chat.is_saled) return true;

      if (this.local_chat.is_brandme_talent) {
        if (this.receiver.id === this.local_chat.creator.id) {
          const review_status = this.local_chat.order_status.find((i) => i.status === 'price_requesting');
          return review_status.is_completed;
        }
        return this.local_chat.brand_can_message
      }

      // PROPOSAL CHATS
      if (this.local_chat.order_status.length > 0 && this.local_chat.user_proposal) {
        if (this.local_chat.user_proposal.seller_status === 'rejected') return false;

        const review_status = this.local_chat.order_status.find((i) => i.status === 'review');
        if (review_status) return !review_status.is_completed;
        else return true
      }

      if (this.local_chat.order_status.length > 0 && this.local_chat.proposal) {
        return this.local_chat.brand.id === getUserData().id ? this.local_chat.brand_can_message : true
      }

      // CASTING CALL CHAT
      if (this.local_chat.order_status.length > 0 && this.local_chat.casting_call) {
        const approved_links_status = this.local_chat.order_status.find((i) => i.status === 'approved_links');
        if (approved_links_status) return !approved_links_status.is_completed;
        else return true
      }
    },
    changeProposal(proposal) {
      this.proposal_active = proposal;
      this.update_preview = !this.update_preview;
    },
    changeDropdown(value) {
      this.option_selected_dropdown = value;
    },
    openSidebarInfo() {
      this.open_modal = true;
    },
    isLastMessage(msg, type_message_evaluated) {
      for (let i = this.local_messages.length - 1; i >= 0; i--) {
        const message = this.local_messages[i];
        if (message.type_message === type_message_evaluated) {
          return message.uuid === msg.uuid;
        }
      }
      return false;
    },
    showButtonsContent(msg) {
      if (this.local_chat.creator.id === this.receiver.id) return false

      const last_message = this.isLastMessage(msg, 'content')
      if (!last_message) return false

      return msg.chat_deal.order_statuses?.length && msg.chat_deal.order_statuses.at(-1).status === "content_submitted" && msg.chat_deal.order_statuses.at(-1).is_completed
    },
    showButtonsLink(msg) {
      if (this.local_chat.creator.id === this.receiver.id) return false

      const last_message = this.isLastMessage(msg, 'link')
      if (!last_message) return false

      return msg.chat_deal.order_statuses?.length && msg.chat_deal.order_statuses.at(-1).status === "approved_links" && !msg.chat_deal.order_statuses.at(-1).is_completed
    },
    setFormatMsg(msg, previous_message_date = null) {
      const sender = this.local_chat.brand.id === msg.sender_id ? this.local_chat.brand : this.local_chat.creator;

      const obj = {
        uuid: msg.uuid,
        sender,
        message: msg.type_message === 'text' || msg.type_message === 'automated' || msg.type_message === 'revision' ? msg.message : msg.link,
        type_message: msg.type_message,
        sended_at: msg.sended_at,
        sender_id: msg.sender_id,
        file: msg.type_message === 'file' || msg.type_message === 'content' ? msg.file : '',
        is_same_date: previous_message_date !== getDatev2(new Date(msg.sended_at)),
        seen: msg.seen,
        text_publish: msg.text,
        chat_deals: msg.chat_deal,
        show_btns: msg.type_message === 'content' ? this.showButtonsContent(msg) : false,
        type_action: msg.type_action,
        show_btns_links: msg.type_message === 'link' ? this.showButtonsLink(msg) : false,
        deal_custom: msg.type_message === 'deal' ? msg : null,
      }

      return obj
    },
    sendFiles(files) {
      this.files = files;
      this.sendMessage();
    },
    parseEmojis(text) {
      if (!text) return text

      return emoji.replace_emoticons(
        text
          .replace(/<3/g, '❤️')
          .replace(/<\/3/g, '💔')
      )
    },
    sendMessage() {
      const rawText = this.message.trim()

      if (rawText.length === 0 && this.files.length === 0) return
      if (!this.ready_to_send_ws) return
      if (existsEmailOrPhoneOrUlr(rawText, !this.local_chat.is_saled)) return

      this.ready_to_send_ws = false;

      if (this.files.length > 0) {
        const form_data = new FormData()
        this.files.forEach(file => {
          form_data.append('files', file)
        })

        this.loaded_files = true

        const ws_send_files = this.isLegacy ? chat_service.uploadFilesInChat : chat_service.uploadFilesInChatV4

        ws_send_files(this.local_chat.uuid, form_data).then((response) => {
          this.ready_to_send_ws = true
          this.loaded_files = false

          if (response?.error) {
            if (response.code === 'chat.archived') {
              this.local_chat.status = 'archived'
              this.can_send_message = false
            }

            loadToastificationContent().then((component) => {
              this.$toast({
                component: component.default,
                position: 'top-right',
                props: {
                  title: this.$t('chat.archivedChatTitle'),
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  text: this.$t('chat.archivedChatError'),
                }
              })
            })

            return
          }

          response.results.forEach(msj_response => {
            const sended_at = Date.now()
            this.local_messages.push({
              sender: {
                id: this.receiver.id,
                first_name: this.receiver.first_name,
                last_name: this.receiver.last_name,
                avatar: this.receiver.avatar,
              },
              message: '',
              type_message: 'file',
              sended_at,
              file: msj_response.file,
              is_same_date: this.getPreviousMessageDate() !== getDatev2(new Date(sended_at)),
            })
          })

          this.message = ''
          this.files = []
          this.$nextTick(() => this.scrollToBottomInChatLog())
        })
      } else {
        const parsedMessage = this.parseEmojis(this.message)

        const ws_send_text = this.isLegacy ? chat_service.sendMessageText : chat_service.sendMessageTextV4

        ws_send_text(this.local_chat.uuid, parsedMessage, this.active_card_chat_uuid || null).then((response) => {
          this.ready_to_send_ws = true

          if (response?.error) {
            if (response.code === 'chat.archived') {
              this.local_chat.status = 'archived'
              this.can_send_message = false
            }

            loadToastificationContent().then((component) => {
              this.$toast({
                component: component.default,
                position: 'top-right',
                props: {
                  title: this.$t('chat.archivedChatTitle'),
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  text: this.$t('chat.archivedChatError'),
                }
              })
            })

            return
          }

          const msg_formatted = this.setFormatMsg(response, this.getPreviousMessageDate())

          this.local_messages.push(msg_formatted)

          this.message = ''
          this.$nextTick(() => this.scrollToBottomInChatLog())

          setTimeout(() => {
            this.links = document.getElementsByClassName('link-url-chat')
            this.links.forEach(link => {
              link.addEventListener('click', this.openModal)
            })
          }, 50)
        })
      }
    },
    formatMessageTime(dateString) {
      const date = new Date(dateString);
      const hours = date.getHours();
      const minutes = date.getMinutes();

      const displayHours = hours % 12 || 12;
      const displayMinutes = minutes.toString().padStart(2, '0');
      const ampm = hours >= 12 ? 'P.M.' : 'A.M.';
      
      return `${displayHours}:${displayMinutes} ${ampm}`;
    },
    scheduleScrollToBottom() {
      this.$nextTick(() => {
        this.scrollToBottomInChatLog()
      })
    },
    getChatLogElement() {
      const chatLogRef = this.$refs?.refChatLogPS
      if (!chatLogRef) return null

      if (chatLogRef.$el) return chatLogRef.$el
      if (chatLogRef instanceof HTMLElement) return chatLogRef
      if (chatLogRef.$refs?.container) return chatLogRef.$refs.container

      return null
    },
    scrollToBottomInChatLog() {
      const scrollEl = this.getChatLogElement()
      if (!scrollEl) return

      scrollEl.scrollTop = scrollEl.scrollHeight
    },
    appendNewMessage(content) {
      const msg_formatted = this.setFormatMsg(content, this.getPreviousMessageDate())
      msg_formatted.deal_info = this.deal_active

      this.local_chat.chat_deals = this.local_chat.chat_deals.map(deal => {
        if (deal.uuid === msg_formatted.chat_deals.uuid) {
          return { ...deal, order_statuses: content.chat_deal.order_statuses }
        }
        return deal
      })
      this.local_messages.push(msg_formatted)
    },
    handleApprovedChatDeal() {
      this.getDealsPaid()
      this.lastMsjContent()
      this.candSendFiles()
      this.canSendLinks()
    },
    handleRequestSentChatDeal(revision) {
      this.getDealsPaid()
      this.appendNewMessage(revision)
      this.lastMsjContent()
      this.candSendFiles()
      this.canSendLinks()
    },
    updateContents(contents) {
      this.getDealsPaid()
      contents.forEach(content => this.appendNewMessage(content))
      this.lastMsjContent()
      this.candSendFiles()
      this.canSendLinks()
    },
    updateChat() {
      this.$emit('update-chat', this.local_chat.uuid)
    },
    confirmToggleArchiveChat() {
      const willArchive = !this.isChatArchived

      this.$swal({
        title: this.$t(willArchive ? 'creator.archiveChatConfirmTitle' : 'creator.unarchiveChatConfirmTitle'),
        text: this.$t(willArchive ? 'creator.archiveChatConfirmText' : 'creator.unarchiveChatConfirmText'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t(willArchive ? 'creator.archiveChatConfirmButton' : 'creator.unarchiveChatConfirmButton'),
        customClass: {
          confirmButton: 'btn confirm-button',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false,
        heightAuto: false
      }).then(result => {
        if (result.value) this.toggleArchiveChat(willArchive)
      })
    },
    toggleArchiveChat(willArchive) {
      this.archiving_chat = true

      const ws_toggle_archive = willArchive ? chat_service.archiveChatV4 : chat_service.unarchiveChatV4

      ws_toggle_archive(this.local_chat.uuid).then((response) => {
        this.archiving_chat = false

        loadToastificationContent().then((component) => {
          if (response?.error) {
            this.$toast({
              component: component.default,
              position: 'top-right',
              props: {
                title: this.$t(willArchive ? 'creator.archiveChatError' : 'creator.unarchiveChatError'),
                icon: 'AlertCircleIcon',
                variant: 'danger',
                text: response.message || '',
              }
            })
            return
          }

          this.local_chat.status = willArchive ? 'archived' : 'active'
          this.can_send_message = this.getCanSendMessage()

          this.$toast({
            component: component.default,
            position: 'top-right',
            props: {
              title: this.$t(willArchive ? 'creator.archiveChatSuccess' : 'creator.unarchiveChatSuccess'),
              icon: 'CheckCircleIcon',
              variant: 'success',
            }
          })

          this.$emit('update-chat', this.local_chat.uuid)
        })
      })
    },
    declinedChat() {
      this.$emit('update-chat', this.local_chat.uuid)
      this.can_send_message = false
      this.local_chat.seller_status = 'rejected';
      this.seller_status = 'rejected';
    },
    isRightSide(sender_id) {
      return getUserData().id === sender_id;
    },
  },
  watch: {
    can_send_message() {
      this.updateChatFooterHeight()
    },
    messages_format: {
      immediate: true,
      handler(messages) {
        this.local_messages = Array.isArray(messages) ? [...messages] : []
        if (!Array.isArray(messages) || messages.length === 0) return
        this.scheduleScrollToBottom()
      },
    },
    chat: {
      handler(new_val, old_val) {
        if (!new_val) return

        this.local_chat = { ...new_val }
        const isConversationChange = new_val.uuid !== old_val?.uuid

        if (isConversationChange) {
          this.update_proposals++
        }

        this.$nextTick(() => {
          this.syncChatState(isConversationChange)
        })
      }
    },
    message(val) {
      if (val.length > 0) {
        this.$refs['send-message-chat'].classList.add('background-blue')
      }
      this.$nextTick(() => {
        const el = this.$refs.textarea
        const chat = this.getChatLogElement()
        if (!el || !chat) return
        el.style.height = "auto"
        const newHeight = Math.min(el.scrollHeight, 100)
        el.style.height = `${newHeight}px`

        const form = this.$el.querySelector('.chat-app-form')
        const formHeight = form ? form.offsetHeight : 65

        chat.style.setProperty("--form-height", `${formHeight}px`)
        this.scrollToBottomInChatLog()
      })
    }
  }
}
</script>
<style>
.add-custom-deal {
  color: white;
}
.chat-message {
  white-space: pre-line;
}


.btn-open-sider:focus {
  background: transparent;
}
.username-buy {
  display: -webkit-box;
 -webkit-line-clamp: 2;
 -webkit-box-orient: vertical;
  overflow: hidden;
  display: block;
  width: 100%;
}
.sidebar-chat > .b-sidebar {
  width: 700px !important;
  overflow-y: scroll;
}
#dropdown-attach-files .dropdown-menu {
  transform: translate3d(-60px, -89px, 0px) !important;
}

</style>
<style scoped lang="scss">
.icon-svg {
  width: 20px;
  filter: brightness(0) invert(1);
}
.chat-upload-contents-chat {
  max-width: 75%;
  margin: 0.5em 0 0 3.5em;
  @media(min-width: 1800px) {
    max-width: 480px;
  }
}
.chat-bubble-content-wrapper {
  display: flex;
  align-items: flex-start;
  max-width: 80%;
  margin-left: auto;
  margin-right: 0;
  flex-direction: row-reverse;
  gap: 0.5rem;

  @media(min-width: 1800px) {
    max-width: 60%;
  }

  .chat-avatar {
    flex-shrink: 0;
  }
  .chat-body {
    flex: 1;
    min-width: 0;
  }
}
.chat-left .chat-bubble-content-wrapper {
  margin-left: 0;
  margin-right: auto;
  flex-direction: row;
}
.custom-dropdown {
  color: black;
}
.active-item {
  background-color: rgba(255, 255, 255, 0.25) !important;
  font-weight: 600;
  color: #fff !important;
  border-radius: 6px;
}
.back-general-chat-btn {
  background-color: #0094fe18;
  color: #0096fe;
  border-radius: 8px;
  font-family: 'avenir-medium';
}
.back-general-chat-btn:hover {
  background-color: #0094fe28;
}
.container-custom-deal-action {
  position: sticky;
  background-color: white;
  padding: 1em;
  bottom: 0;
  border-top: 1px solid #ebe9f1;
  width: 100%;
  z-index: 100;
}
.text-overflow-title-chat-proposals {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #212529;
  font-size: 12px;
}
.badge-chat-active {
  background-color: #0094fe18;
  color: #0096fe;
  padding: 4px 10px;
  border-radius: 99px;
}
.textarea-send-message {
  width: 100%;
  height: 40px;
  max-height: 100px;
  resize: none;
  padding: 0.6rem 1rem;  
  border: 1px solid #ccc;
  border-radius: 6px;
}
.textarea-send-message:focus {
  border-color: #5582f6;
}
.container-msg-restrincted {
  width: 100%;
  background-color: white;
  position: sticky;
  bottom: 0;
  border-radius: 1em;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  border: 1px solid #5582f6;
  background-color:rgb(229, 233, 248);
  font-family: 'avenir-medium';
  padding: 2em 1em 2em 1.5em;
  overflow: hidden;
  .bar-color {
    background-color: #5582f6;
    position: absolute;
    top: 0;
    left: 0;
    width: 10px;
    height: 100%;
  }
}
.send-message-chat {
  background-color: #BFBFBF;
  border-radius: 100%;
  width: 37px;
  height: 37px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 10;
  transition: all 300ms;
  .message-icon-svg {
    width: 20px;
    height: 20px;
  }
}
.background-blue {
  background-color: #5582f6 !important;
}
.open-sidebar-icon {
  color: #82868b;
}
.width-proposal-right-chat, .container-right-side {
  width: 420px !important;
  max-width: 420px !important;
  min-width: 420px !important;
}
.width-proposal-right-chat {
  flex: auto;
  margin: 0 0 0 0;
}
.flex-auto-container {
  flex: auto;
  min-width: 0;
  overflow-x: hidden;
  border-right: 1px solid #ebe9f1;
}
.container-right-side {
  overflow-y: auto;
  position: relative !important;
  overflow-x: hidden;
}
.dropdown-sales-options {
  background-color: white;
  height: 65px;
  position: sticky;
  top: 0;
  z-index: 100;
  width: 420px;
  border-bottom: 1px solid #ebe9f1;
  display: flex;
  justify-content: center;
}
.dropdown-sales-options-sidebar {
  width: 100%;
}
.w-90 {
  width: 95%;
}
.hour-message-container {
  font-family: 'avenir-light';
  display: block;
  width: 100%;
  padding: 0em 4.5em;
  font-size: 12px;
  font-weight: 100;
  .check-icon-seen {
    font-size: 18px;
  }
  .seen-color {
    color: rgb(13, 131, 228);
  }
}
.chat {
  .hour-message-container {
    text-align: end;
  }
}
.chat-left {
  .hour-message-container {
    text-align: start;
  }
}
.badge-date-chat {
  background-color: #dcdcdc52;
  color: rgba(0, 0, 0, 0.473);
  border-radius: 1em;
  font-family: 'avenir-light';
  font-weight: 500;
  padding: 5px
}
.loader-uploading-files {
  color: #ccc;
  background-color: white;
  position: absolute;
  padding: 5px;
  right: 0;
}
.spinner-uploading-files { 
  width: 25px;
  height: 25px;
}
.close-sidebar-icon {
  position: absolute;
  top: 1em;
  right: 1em;
}
.close-sidebar-icon:hover {
  background-color: rgba(219, 219, 219, 0.5);
  border-radius: 50%;
  cursor: pointer;
}
.chat-application .chat-app-window .user-chats {
  background-color: white !important;
  background-image: none;
  height: calc(100% - 65px - var(--form-height, 65px)) !important;
}
.chat-application .chat-app-form {
  padding: 1em;
  height: auto !important;
  align-items: start !important;
}
.chat-app-window .chats .chat-body .chat-content{
  box-shadow: none;
  border-radius: 1em;
  word-break: break-word;
}
.chat-app-window .chats .chat-body .chat-content {
  margin: 0 1rem 5px 0;
}
.chat-app-window .chats .chat-left .chat-body .chat-content {
  background-color: #f5f5f5;
  font-family: 'avenir-medium';
  display: block;
  position: relative;
  width: auto;
  margin: 0 0 5px 1rem;

  &::before {
    border: 10px solid #f5f5f5;
    content: '';
    border-left-color: transparent;
    border-bottom-color: transparent;
    border-right-color: transparent ;
    position: absolute;
    top: 0;
    left: -10px;
  }
  &::after {
    border: 10px solid transparent !important;
    content: '' !important;
  }
}
.chat-bot {
  background-color: #0059db !important;
  color: white !important;
  padding: 1em !important;
  border-radius: 0.5em !important;
  &::before {
    border: 10px solid  #0059db !important;
    content: '' !important;
    border-left-color: transparent !important;
    border-bottom-color: transparent !important;
    border-right-color: transparent !important;
    position: absolute !important;
    top: 0 !important;
    left: -10px !important;
  }
}
.hour-message {
  color: rgba(0, 0, 0, 0.473);
}
.chat-app-window .chats .chat-body .chat-content {
  background-color: #D9E7FA;
  color: black;
  font-family: 'avenir-medium';
  background-image: none;
  &::after {
    border: 10px solid #D9E7FA !important;
    content: '' !important;
    border-left-color: transparent !important;
    border-bottom-color: transparent !important;
    border-right-color: transparent !important;
    border-top-color: transparent;
    position: absolute !important;
    right: 5px !important;
    top: 1em;
  }
}
.outline-secondary-light {
  border: 1px solid #d8d6de;
}
.outline-secondary-light:hover {
  background-color: #f1f1f1;
}
.dropdown-menu[x-placement^=top] , .dropup > .dropdown-menu, .dropdown-menu  {
  left: -4em !important;
}
.container-badges-files {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  align-items: center;
}
.badges-files {
  display: flex;
  align-items: center;
  overflow-x: scroll;
}
.loader-inner-active-chat {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}
.spinner-inner-active-chat {
  height: 6em;
  width: 6em;
  color: #acacac;
}
.text-ellipsis-url {
  word-break: break-all;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 100%;
}
.card-deal-custom-container {
  min-width: 200px;
  max-width: 400px;
  display: flex;
}

// Responsive for mobiles
@media (max-width: 768px) {
  .flex-auto-container {
    width: 100%;
    max-width: 100%;
  }
  .user-chats,
  .chats,
  .chat,
  .chat-body {
    min-width: 0;
    max-width: 100%;
  }
  .chat-bubble-content-wrapper {
    max-width: 100%;
    min-width: 0;
    gap: 0.35rem;
  }
  .chat-bubble-content-wrapper .chat-body {
    min-width: 0;
  }
  .chat-app-window .chats .chat-body .chat-content {
    max-width: 85%;
    word-break: break-word;
    overflow-wrap: anywhere;
  }
  .chat-app-window .chats .chat-body {
    margin-right: 0.5rem;
  }
  .chat-app-window .chats .chat-left .chat-body {
    margin-left: 0.5rem;
  }
  .hour-message-container {
    padding: 0 1.25em;
  }
  .chat-upload-contents-chat {
    max-width: 90%;
    margin-left: 2.5em;
  }
  .card-deal-custom-container {
    min-width: 0;
    max-width: 100%;
    width: 100%;
  }
  .view-file-chats-component,
  .card-type-content,
  .card-image-content {
    max-width: 100%;
  }
}
</style>
